import { render } from "./Ricetta.vue?vue&type=template&id=a4d7423c&scoped=true"
import script from "./Ricetta.vue?vue&type=script&lang=js"
export * from "./Ricetta.vue?vue&type=script&lang=js"

import "./Ricetta.vue?vue&type=style&index=0&id=a4d7423c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d7423c"]])

export default __exports__